"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formatCnpj = _interopRequireDefault(require("@brazilian-utils/format-cnpj"));

var _isValidCnpj = _interopRequireDefault(require("@brazilian-utils/is-valid-cnpj"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var InputCNPJ = function InputCNPJ(_ref) {
  var valid = _ref.valid,
      id = _ref.id,
      label = _ref.label,
      errorMessage = _ref.errorMessage,
      className = _ref.className,
      size = _ref.size,
      withShadow = _ref.withShadow,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onValidate = _ref.onValidate,
      props = _objectWithoutProperties(_ref, ["valid", "id", "label", "errorMessage", "className", "size", "withShadow", "onChange", "onBlur", "onValidate"]);

  var _useState = (0, _react.useState)(props.value),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(valid === false),
      _useState4 = _slicedToArray(_useState3, 2),
      showError = _useState4[0],
      setShowError = _useState4[1];

  var _useState5 = (0, _react.useState)(valid === true),
      _useState6 = _slicedToArray(_useState5, 2),
      showSuccess = _useState6[0],
      setShowSuccess = _useState6[1];

  (0, _react.useEffect)(function () {
    if (valid === true || valid === false) {
      setShowSuccess(valid);
      setShowError(!valid);
    }
  }, [valid]);
  (0, _react.useEffect)(function () {
    if (props.value) {
      checkValid(props.value);
    }
  }, [props.value]);
  (0, _react.useEffect)(function () {
    setValue(props.value);
  }, [props.value]);

  var handleChange = function handleChange(event) {
    setValue(event.target.value);
    onChange(event);
  };

  var handleBlur = function handleBlur(event) {
    var isValid = checkValid(event.target.value);
    onBlur(event);
    onValidate(isValid);
  };

  var checkValid = function checkValid(value) {
    var isValid = (0, _isValidCnpj.default)(value);
    setShowError(!isValid);
    setShowSuccess(isValid);
    return isValid;
  };

  var wrapperClass = 'input';
  if (className) wrapperClass += " ".concat(className);
  if (size === 'small') wrapperClass += ' input--small';
  if (withShadow) wrapperClass += ' input--shadow';
  var inputClass = 'input__field';
  if (showSuccess) inputClass += ' input__field--success';
  if (showError) inputClass += ' input__field--error';
  return _react.default.createElement("div", {
    className: wrapperClass
  }, _react.default.createElement("input", _extends({}, props, {
    type: "text",
    id: "cnpj",
    className: inputClass,
    value: (0, _formatCnpj.default)(value),
    onChange: handleChange,
    onBlur: handleBlur
  })), _react.default.createElement("label", {
    className: "input__label",
    htmlFor: id
  }, label), showError && _react.default.createElement("p", {
    className: "input__error-message"
  }, errorMessage));
};

InputCNPJ.defaultProps = {
  errorMessage: 'CNPJ Inválido',
  valid: null,
  value: '',
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onValidate: function onValidate() {}
};
InputCNPJ.propTypes = {
  /** Muda a cor da borda e exibe a mensagem de erro se verdadeiro */
  valid: _propTypes.default.bool,

  /** id do input */
  id: _propTypes.default.string.isRequired,

  /** Label que referencia o input */
  label: _propTypes.default.string.isRequired,

  /** Mensagem de erro customizada */
  errorMessage: _propTypes.default.string,

  /** Classe adicional para o wrapper */
  className: _propTypes.default.string,

  /** Callback para quando modificar o value do input */
  onChange: _propTypes.default.func,

  /** Callback para quando o focus sair do input */
  onBlur: _propTypes.default.func,

  /** Callback para saber se deu erro na validação */
  onValidate: _propTypes.default.func,

  /** O tamanho do input */
  size: _propTypes.default.oneOf(['small'])
};
var _default = InputCNPJ;
exports.default = _default;